"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InputField = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * InputFields allow users to enter text into a UI. They typically appear in
 * forms and dialogs. The InputFields wrapper component is a complete form
 * control including a label, input and optional error text.
 *
 * The prop interface accepts all props supported by the  `Input` component,
 * which it renders internally and passes those props to. All other props
 * and HTML attributes are passed to the root node.
 *
 * If you need to pass any DOM attributes to the Input component that aren't
 * part of it's explicit prop interface, you can do so by adding them to the
 * `InputProps` prop, which is an object that will be spread as prop value
 * declarations to the Input component.
 */
const InputField = /*#__PURE__*/React.forwardRef(({
  after,
  before,
  className,
  disabled = false,
  error,
  helpContent,
  id,
  InputProps,
  label,
  placeholder,
  required = false,
  showValidationIcons,
  type = 'text',
  variant,
  valid,
  value,
  ...otherProps
}, ref) => {
  const disabledLabelColor = disabled ? 'disabled.2' : undefined;
  const hasError = !!error;
  return (0, _pragma.createFelaElement)(_.View, _extends({
    className: className,
    flexDirection: "column",
    gap: "xsmall"
  }, otherProps), (0, _pragma.createFelaElement)(_.Text, {
    as: "label",
    children: label,
    color: disabledLabelColor,
    htmlFor: id,
    variant: "body",
    weight: "bold"
  }), (0, _pragma.createFelaElement)(_.Input, _extends({
    after: after,
    before: before,
    disabled: disabled,
    error: !!error,
    id: id,
    placeholder: placeholder,
    ref: ref,
    required: required,
    showValidationIcons: showValidationIcons,
    type: type,
    valid: valid,
    value: value,
    variant: variant
  }, InputProps)), (0, _pragma.createFelaElement)(_.Text, {
    "data-qa": "info-message",
    children: hasError ? error : helpContent,
    color: hasError ? 'text.negative' : disabledLabelColor,
    variant: "meta"
  }));
});
exports.InputField = InputField;
InputField.displayName = 'InputField';
var _default = InputField;
exports.default = _default;
//# sourceMappingURL=InputField.js.map